import { faAnchor } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Layout } from "antd"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

const { Header } = Layout

const StyledHeader = styled(Header)`
  position: sticky;
  top: 0;
  background-color: #002766;
  width: 100%;
  z-index: 10;
`
const StyledTitle = styled.div`
  font-size: 18px;
  color: white;
  font-weight: 600;
`
export const DefaultHeader = () => {
  return (
    <StyledHeader>
      <Link to="/">
        <StyledTitle>
          <StyledFontAwesomeIcon icon={faAnchor} />
          船員求人広告
        </StyledTitle>
      </Link>
    </StyledHeader>
  )
}

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-right: 8px;
`
